import React from "react";

export default function ProductCouleurTable({
  ListProductCouleur,
  onEditClick,
  deleteitem,
}: any) {
  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>libelle</th>
          <th>code couleur</th>
          <th className="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        {ListProductCouleur.map((item: any) => (
          <tr key={item._id}>
            <td> {item.libelle}</td>
            <td> {item.code_couleur}</td>
            <td className="text-center">
            <ul className="table-controls">
                <li onClick={() => deleteitem(item._id)} >
                  <i
                    className="fas fa-trash-alt fa-lg"
                    style={{ color: "#14d8db" }}
                  ></i>
                </li>
                <li onClick={() => onEditClick(item)}>
                  <i
                    className="fas fa-pen fa-lg"
                    style={{ color: "#14d8db"}}
                  ></i>
                </li>
              </ul>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
